import styled from "styled-components";
import { PageHeaderWrapper } from "@cdkglobal/radial";

export const StyledPageHeaderWrapper = styled(PageHeaderWrapper)<{
  $hideDivider?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 101;
  ${({ $hideDivider }) => $hideDivider && "border-bottom: none;"}
`;

export const StyledPageHeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledPageHeaderButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding-right: 1rem;
`;
